import { LogOut, Target } from 'lucide-react'
import { NavLink } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { WolfMark } from '../brand/WolfMark'
import { NAV_ITEMS } from './navigation'
import { QuickActionMenu } from './QuickActionMenu'

export function Sidebar({
  onAddNewProspect,
  onAddSalesperson,
  onSetReminder,
  onReviewMissingInformation,
  onOpenScript,
}: {
  onAddNewProspect: (trigger: HTMLButtonElement) => void
  onAddSalesperson?: (trigger: HTMLButtonElement) => void
  onSetReminder: (trigger: HTMLButtonElement) => void
  onReviewMissingInformation: (trigger: HTMLButtonElement) => void
  onOpenScript?: (trigger: HTMLButtonElement) => void
}) {
  const { logout } = useAuth()

  return (
    <aside className="sidebar" aria-label="Primary navigation">
      <div className="sidebar-brand">
        <WolfMark className="sidebar-wolf" />
        <div className="sidebar-wordmark">
          <span>WILLIAM'S</span>
          <small>TREASURE</small>
        </div>
      </div>

      <nav className="sidebar-nav">
        {NAV_ITEMS.map(({ label, to, icon: Icon }) => (
          <NavLink
            className={({ isActive }) => `sidebar-link${isActive ? ' is-active' : ''}`}
            key={to}
            to={to}
          >
            <Icon aria-hidden="true" size={20} strokeWidth={1.8} />
            <span>{label}</span>
          </NavLink>
        ))}
        <NavLink
          className={({ isActive }) => `sidebar-link${isActive ? ' is-active' : ''}`}
          to="/prospecting"
        >
          <Target aria-hidden="true" size={20} strokeWidth={1.8} />
          <span>Prospecting</span>
        </NavLink>
      </nav>

      <QuickActionMenu onAddNewProspect={onAddNewProspect} onAddSalesperson={onAddSalesperson} onSetReminder={onSetReminder} onReviewMissingInformation={onReviewMissingInformation} onOpenScript={onOpenScript} variant="desktop" />

      <div className="sidebar-user">
        <div>
          <strong>William Jones</strong>
          <span>Owner</span>
        </div>
        <button className="sidebar-logout" onClick={logout} type="button" aria-label="Sign out">
          <LogOut size={18} strokeWidth={1.8} />
        </button>
      </div>
    </aside>
  )
}
